import { render, staticRenderFns } from "./ConfirmChargeModal.vue?vue&type=template&id=c5fb5e72&scoped=true&"
import script from "./ConfirmChargeModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb5e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5fb5e72')) {
      api.createRecord('c5fb5e72', component.options)
    } else {
      api.reload('c5fb5e72', component.options)
    }
    module.hot.accept("./ConfirmChargeModal.vue?vue&type=template&id=c5fb5e72&scoped=true&", function () {
      api.rerender('c5fb5e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/ConfirmChargeModal.vue"
export default component.exports